import { Reducer } from 'redux';
import { UnitUsageType } from "models/UnitUsageType";
import { IUnitUsageTypeActions, UnitUsageTypeActionType } from "redux/actions/settings/UnitUsageTypeActions";

const initialState: UnitUsageType[] | null = null;
export const unitUsageTypesReducer: Reducer<UnitUsageType[] | null, IUnitUsageTypeActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case UnitUsageTypeActionType.FETCH_UNITUSAGETYPES_SUCCESS:
                {
                    return action.returnPayload as UnitUsageType[];
                }
            default:
                return state;
        }
    };
